import ProductSpecs from '@elem/compCommon/ProductConstructor/Specs';
import { useProductStore } from '../../ProductProvider';
import GetProductData from '../GetProductData';

export default function TabSpecs({ theme }: { theme: any }) {
    const { productPageData } = useProductStore();
    const { spuId } = productPageData;

    return (
        <>
            {spuId && <ProductSpecs productCatagory={productPageData.productCatagory} productDetail={productPageData.productDetail} theme={theme} />}
            <GetProductData />
        </>
    );
}
